import { unifiedDataStore } from '../store/unifiedDataStore';

export type DatasetInfoResponse = {
  success: boolean;
  data?: {
    date_modified?: string;
    date?: string;
    source_id?: number | string;
    [key: string]: unknown;
  };
};

/**
 * Cached dataset metadata fetch — routes all /datasets/info traffic through unifiedDataStore.
 */
export async function fetchDatasetInfo(
  className: string,
  projectId: number,
  datasetId: number
): Promise<DatasetInfoResponse> {
  return unifiedDataStore.getDatasetInfo(className, projectId, datasetId);
}

/**
 * Normalize dataset date to YYYYMMDD for file API paths.
 */
export function datasetDateToYmd(raw: string | null | undefined): string | null {
  if (!raw || typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  return trimmed.replace(/[-/]/g, '');
}
